export default "/react/getRadioIcon-1e160e47.svg";